<template>
  <div>
    <v-autocomplete
      outlined
      v-if="readonly === false"
      dense
      v-model="select"
      :items="Lista"
      item-text="descripcion_parentesco"
      item-value="id_parentesco"
      label="Parentesco"
      persistent-hint
      return-object
      @change="$emit('input', select.id_parentesco)"
      hide-details
    ></v-autocomplete>
    <v-text-field
      hide-details
      dense
      label="Parentesco"
      v-if="readonly===true"
      filled
      readonly
      :value="select.descripcion_parentesco"
      outlined
    ></v-text-field>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  props: {
    value: Number,
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      select: {
      }
    };
  },
  computed: {
    ...mapState("parentesco", ["Lista"]),
  },
  methods: {
    ...mapActions("parentesco", ["setParentesco"]),
    seleccionar(id) {
      if (id != undefined) {
        let pr = this.Lista.find(x => x.id_parentesco == id);
        if (pr) {
          this.select = pr;
        } else {
          this.seleccionar("0");
        }
      }
    }
  },
  async mounted() {
    let id = this.value;
    this.seleccionar(id);
  },
  watch: {
    value: function(newVal, oldVal) {
      this.seleccionar(newVal);
    }
  }
};
</script>

<style>
</style>